module.exports = __webpack_public_path__ + "media/theme/ico-error-1-d5d3af43.png";